import { Component } from '@angular/core';
import { AuthService } from '../../../modules/security/service/auth.service';
import { TranslatePipe } from '../../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-footer',
  templateUrl:
    './console/app-js/app/components/footer/app-footer.component.html',
  providers: [TranslatePipe],
  styles: [``]
})
export class AppFooterComponent {
  constructor(private authService: AuthService) {
    // Silence is golden.
  }

  /**
   * Checks if user is logged in.
   * @returns {boolean}
   */
  protected isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }
}
